<template>
	<el-dialog :close-on-click-modal="false"  :title="$t('model.editInfo')" :visible.sync="infoModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表單内容 -->
		<el-form :rules="info_rules" ref="form_info" :model="form_info" label-width="100px">
			<el-form-item :label="$t('model.head')">
			
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'agHead'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="form_info.headUrl" :src="form_info.headUrl" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				
			</el-form-item>
			<el-form-item :label="$t('model.name')" prop="name">
				<el-input :disabled="true" v-model="form_info.name" :placeholder="$t('model.name')" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
			
		<!-- 	<el-form-item :label="$t('model.tg_id')" prop="tg_id">
				<el-input v-model="form_info.tg_id" :placeholder="$t('model.tg_id')" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item> -->
			
			
			<!-- <el-form-item :label="$t('model.tg_qr')">
			
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'agTg'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess2"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="form_info.tg_qr" :src="form_info.tg_qr" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				
			</el-form-item> -->
		
			<!-- <el-form-item label="排序">
		<el-input-number size="small" v-model="form.order" :min="0"></el-input-number>
	</el-form-item> -->
			
	
		</el-form>
	
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<el-button type="primary" @click="submitinfo">{{$t('model.success')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			infoModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form_info:{
					headUrl:user.head?user.head:'',
					headId:0,
					name:user.name,
					tg_id:user.tg_id,
					tg_qr:user.tg_qr?user.tg_qr:'',
				},
				info_rules: {
					name: [{
						required: true,
						message:  this.$t('model.inpName'),
						trigger: 'blur',
					}, ],
				
		
				},
			}
		},

		methods:{
			handleAvatarSuccess(res, file) {
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					console.log(res.encryption.data.list.url)
					this.form_info.headUrl = res.encryption.data.list.url
				}
			 },
			 
			 handleAvatarSuccess2(res, file) {
			 	let en_data = commondecrypt(res.encryption)
			 	res.encryption = JSON.parse(en_data)
			 	if(res.encryption.code==1){
					console.log(res.encryption.data.list.url)
			 		this.form_info.tg_qr = res.encryption.data.list.url
			 	}
			  },
		 beforeAvatarUpload(file) {
		 
		     const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
		     const isLt2M = file.size / 1024 / 1024 < 12;
		 
		     if (!isJPG) {
		     this.$message.error(this.$t('message.info_err'));
		     }
		     if (!isLt2M) {
		     this.$message.error(this.$t('message.img_max_err'));
		     }
		     return isJPG && isLt2M;
		 
		    },
			hide(){
				this.$emit('hide')
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form_info, 'headUrl', res[0].url);
					this.form_info['headId'] = res[0].id
					this.$set(this.form_info, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			//提交
			submitinfo() {
				this.$refs.form_info.validate(res => {
					if (res) {
						
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.axios.post('/admin/user/editInfo', this.form_info, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						user.name = this.form_info.name
						user.head = this.form_info.headUrl
						user.tg_id = this.form_info.tg_id
						user.tg_qr = this.form_info.tg_qr
						window.sessionStorage.setItem('user',JSON.stringify(user))
						this.$message({
							message:  all.msg,
							type: 'success'
						});
						this.hide()
					}
				}).catch(err => {
					
				})
			}
			
		}
	}
</script>

<style>
</style>
